export default "__VITE_ASSET__DKGnvZiP__"